<template>
  <div class="gmf-comment-image-thumbnail-container gmf-clearfix">
    <div v-for="(image, index) in images" :key="image.thumbnailUrl" class="gmf-image-thumbnail-wrapper" @click.stop="openGallery(index)">
      <div class="gmf-image-thumbnail" :style="{'background-image': 'url(' + image.thumbnailUrl + ')'}"/>
    </div>
  </div>
</template>

<style>
.gmf-comment-image-thumbnail-container .gmf-image-thumbnail-wrapper {
  margin-right: 12px;
  margin-bottom: 12px;
  width: 80px;
  height: 80px;
  cursor: pointer;
}
.gmf-comment-image-thumbnail-container {
  margin-top: 12px;
}

@media (max-width: 480px) {
  .gmf-comment-image-thumbnail-container .gmf-image-thumbnail-wrapper {
    width: 64px;
    height: 64px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 3px;
  }
}
</style>

<script>
import modal from '@/utils/modal'
import { defineAsyncComponent } from 'vue';

const ImageGalleryModal = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/ImageGalleryModal');
});

export default {
  props: ['images', 'clickHandler'],
  methods: {
    openGallery (initialIndex) {
      if (this.clickHandler) {
        this.clickHandler(initialIndex);
        return;
      }
      modal.create(ImageGalleryModal, true, {
        provide: {
          initialIndex,
          images: this.images,
        },
      });
    },
  },
};
</script>
